import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  patientId: yup.number(),
  templateId: yup.number().nullable(),
  clinicId: yup.number().required(),
  senderId: yup.number(),
  faxNumber: yup.string(),
  text: yup.string(),
  attachments: yup.array(),
});

export const useEfaxPatientMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const validatedDto = requestSchema.validateSync(dto, {
        strict: true,
      });

      // If there are attachments, use FormData
      if (validatedDto.attachments && validatedDto.attachments.length > 0) {
        const formData = new FormData();
        formData.append("patientId", validatedDto.patientId);
        if (validatedDto.templateId !== null) {
          formData.append("templateId", validatedDto.templateId);
        }
        formData.append("clinicId", validatedDto.clinicId);
        formData.append("senderId", validatedDto.senderId);
        formData.append("faxNumber", validatedDto.faxNumber);
        formData.append("text", validatedDto.text);

        validatedDto.attachments.forEach((file) => {
          formData.append("attachments[]", file);
        });

        return http.post(HTTP_ENDPOINTS.efax.createFaxes(), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      // No attachments, send as JSON
      const { attachments: _attachments, ...dataToSend } = validatedDto;
      return http.post(HTTP_ENDPOINTS.efax.createFaxes(), dataToSend);
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.efax.faxes],
        });

        options?.onSuccess?.(...args);
      },
    },
  );
};
